/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetFloorplans200ResponseValue,
} from '../models/index';
import {
    GetFloorplans200ResponseValueFromJSON,
    GetFloorplans200ResponseValueToJSON,
} from '../models/index';

/**
 * 
 */
export class FloorplansApi extends runtime.BaseAPI {

    /**
     */
    async getFloorplansRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: GetFloorplans200ResponseValue; }>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/floorplans`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => runtime.mapValues(jsonValue, GetFloorplans200ResponseValueFromJSON));
    }

    /**
     */
    async getFloorplans(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: GetFloorplans200ResponseValue; }> {
        const response = await this.getFloorplansRaw(initOverrides);
        return await response.value();
    }

}
